import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CustomNextArrow, CustomPrevArrow } from "../../utility/CustomArrow";
import dentalbanner from "../../../assets/banners/5.webp";
import academybanner from "../../../assets/banners/9.webp";
import homecarebanner from "../../../assets/banners/10.webp";
import weightlossbanner from "../../../assets/banners/6.webp";
import { Link } from "react-router-dom";
import bannervideo from "../../../assets/banners/video.mp4";
import offerbanner from "../../../assets/banners/websitebanner.webp";

const FirstBannerSection = ({ data, language }) => {
  const banner = [
    { src: offerbanner, alt: "offer banner", link: "/offers" },
    {
      src: dentalbanner,
      alt: "hollywood smile",
      link: "/services/hollywood-smile-dubai/",
    },
    { src: academybanner, alt: "ebh academy", link: "https://ebhacademy.com/" },
    {
      src: homecarebanner,
      alt: "homecare banner",
      link: "https://ebhhealthcare.com/",
    },
    {
      src: weightlossbanner,
      alt: "weightloss dubai",
      link: "/services/weight-loss-injections/",
    },
  ];

  const mainSliderSettings = {
    dots: true,
    infinite: data?.data_values.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    autoplaySpeed: 3000,
    arrows: true,
  };

  return (
    <section className="container text-center py-3 mt-5 mb-5">
      <div className="row justify-content-center">
        <div className="col-lg-10 col-md-12 mb-4">
          <h1
            className="fw-bold fade-in"
            style={{ color: "#c69933", fontSize: "3rem" }}
          >
            {language === "ar"
              ? " وجهتك الصحية الأولى: رعاية متخصصة في مختلف المجالات الطبية "
              : "Your Health Hub: Expert Care Across Multiple Specialties "}
          </h1>
          {language === "ar" ? (
            <>
              <p className="text-muted fade-in delay-1 h6">
                مرحبًا بك في عيادات ايليت بودي هوم! يسرّ فريقنا الخبير والودود
                أن يرحّب بكم، نُقدّم رعاية شاملة وعالية الجودة في مختلف التخصصات
                الطبية، على يد نخبة من الأطباء المهرة، ضمن بيئة مريحة ومرحّبة.
              </p>
              <p className="text-muted fade-in delay-2 h6  mt-5">
                نحرص في ايليت بودي هوم على شعورك بالراحة والثقة منذ اللحظة التي
                تخطو فيها إلى عيادتنا. نحن هنا لإرشادك، والإجابة على جميع
                استفساراتك، وضمان أن تكون رحلتك للعناية بالبشرة سلسة وممتعة.
                استكشف خدماتنا، ولنبدأ معًا هذه الرحلة المتألقة!
              </p>
            </>
          ) : (
            <>
              <p className="text-muted fade-in delay-1 h6">
                Welcome to Elite Body Home Polyclinic! Our warm and experienced
                team is excited to meet you. We offer comprehensive,
                high-quality care across various specialties, delivered by
                skilled doctors in a welcoming environment.
              </p>
              <p className="text-muted fade-in delay-2 h6  mt-5">
                At Elite Body Home, we focus on making you feel comfortable and
                confident from the moment you walk through our doors. We’re here
                to guide you, answer your questions, and ensure your skincare
                journey is smooth and enjoyable. Explore our services, and let’s
                start this radiant journey together!
              </p>
            </>
          )}
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-10 col-md-12">
          <Slider {...mainSliderSettings}>
            {banner.map((banner, index) => (
              <div key={index} className="text-center">
                <Link to={banner.link}>
                  <img
                    src={banner.src}
                    alt={banner.alt}
                    className="img-fluid rounded d-block mx-auto"
                    style={{ maxHeight: "450px", objectFit: "contain" }}
                  />
                </Link>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default FirstBannerSection;
